module.exports = __webpack_public_path__ + "static/img/u31.694a28f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kexie/regen/u31.svg
// module id = gDbl
// module chunks = 0